// extracted by mini-css-extract-plugin
module.exports = {"dropOverUpward":"DraggableItem_dropOverUpward__CY9i7","dropOverDownward":"DraggableItem_dropOverDownward__4VZ_e"};